import { http } from '../../src/lib/http'

const GlobalValues = {
  data: {},
  fetchGlobalSettings () {
    return http.get(
      {
        url: '/settings/global',
        params: {},
      },
      (response) => this.getGlobalSettingsSuccessful(response),
      (error) => this.getGlobalSettingsFailure(error)
    )
  },
  getGlobalSettingsSuccessful (response) {
    const results = response.data.result
    // Add the global settings
    this.data = results.global
  },
  getGlobalSettingsFailure (error) {
    console.error('Error while getting global settings', error)
  },
}

export default GlobalValues



// WEBPACK FOOTER //
// ./src/lib/values.js